import Vue from 'vue'
import SmartTable from 'vuejs-smart-table'

Vue.use(SmartTable)
